<template>
  <li
    :class="[menuItem.id == newRootPageId ? 'top' : '', 'nav-item lvl' + level, menuItem.isPersonalizedLink ? 'personalized-link' : '']"
  >
    <div class="linkwrapper">
      <a
        :class="[
          this.isActive ? 'active' : '',
          this.isActiveParent ? 'active-parent' : '',
          'nav-link',
        ]"
        :href="this.menuItem.url"
        v-on:click="setAsActive(this.menuItem.url, $event)"
        :aria-current="this.isActive ? 'page' : false"
      >
        {{ menuItem.name }}
      </a>
      <MenuButton
        v-if="menuItem.hasChildren && level < 4"
        :menuItem="menuItem"
        :showLinksText="showLinksText"
        :expanded="expanded"
        @toggleMenu="toggleMenu"
      ></MenuButton>
    </div>
    <MenuList
      v-if="nextLevel && nextLevel.menuItems.length"
      :baseApiUrl="baseApiUrl"
      :menuItems="nextLevel.menuItems"
      :rootPageId="newRootPageId"
      :currentPageId="currentPageId"
      :currentActiveId="currentActiveId"
      :parentId="menuItem.id"
      :path="path"
      :level="level"
      :showLinksText="showLinksText"
      :expanded="expanded"
      @setActiveLink="setActiveLink"
    ></MenuList>
  </li>
</template>
<script>
import MenuButton from "./MenuButton.vue";
import { defineAsyncComponent } from "vue";
import loadview from "../../../script/loadview";
import UrlInfo from "../../../script/urlInfo";
export default {
  name: "MenuItem",
  props: {
    menuItem: Object,
    rootPageId: Number,
    currentPageId: Number,
    currentActiveId: Number,
    parentId: Number,
    path: Array,
    baseApiUrl: String,
    level: Number,
    showLinksText: String,
  },
  emits: {
    setActiveLink: null,
    loadPartialView: null,
  },
  data: function () {
    return {
      nextLevel: undefined,
      expanded: false,
      isActive: false,
      isActiveParent: false,
      newRootPageId: 0,
      linkFailed: false,
    };
  },
  components: {
    MenuButton,
    MenuList: defineAsyncComponent(() => import("./MenuList.vue")),
  },
  inject: {
    activeLink: "activeLink",
    activeParentLink: "activeParentLink",
    currentExpanded: "currentExpanded",
    menuservice: "menuservice",
    userOrganisationUids: "userOrganisationUids",
    userProgramCodes: "userProgramCodes",
    userUmuId: "userUmuId",
    navigatedText: "navigatedText",
  },
  watch: {
    activeLink: {
      deep: true,
      handler(linkId) {
        if (linkId == this.menuItem.id) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      },
    },
    activeParentLink: {
      deep: true,
      handler(linkId) {
        if (linkId == this.menuItem.id && this.level == 3) {
          this.isActiveParent = true;
        } else {
          this.isActiveParent = false;
        }
      },
    },
    currentExpanded: {
      deep: true,
      handler(target) {
        if (!this.$el.contains(target)) {
          this.expanded = false;
        }
      },
    },
  },
  beforeMount() {
    if (this.rootPageId == 0) {
      this.newRootPageId = this.menuItem.id;
    } else {
      this.newRootPageId = this.rootPageId;
    }

    this.loadMenu();
  },
  mounted() {
    if (
      this.menuItem.isActive ||
      this.menuItem.id == this.currentPageId ||
      this.menuItem.id == this.currentActiveId
    ) {
      this.setActiveLink(this.menuItem.id, this.parentId, this.$el);
    }
  },
  methods: {
    loadMenu: function () {
      if (
        (this.path &&
          this.path.length &&
          this.path.includes(this.menuItem.id) &&
          this.menuItem.id != this.rootPageId) ||
        (this.menuItem.id == this.rootPageId && this.menuItem.hasActiveChildren)
      ) {
        if (this.level < 4 && this.menuItem.hasChildren) {
          this.getNextLevel(this.menuItem.id, this.menuItem.childSortOrder);
        }
      }
      if (
        this.menuItem.id == this.currentPageId &&
        this.menuItem.hasChildren &&
        !this.expanded
      ) {
        this.toggleMenu(this.menuItem.id, this.menuItem.childSortOrder);
      }
    },
    toggleMenu: function (id, sort) {
      if (this.level < 4) {
        if (!this.nextLevel || !this.nextLevel.menuItems.length) {
          this.getNextLevel(id, sort);
        } else if (this.expanded) {
          this.expanded = false;
        } else {
          this.expanded = true;
        }
      }
    },
    setAsActive: function (url, event) {
      let urlInfo = new UrlInfo(url);
      if (!this.linkFailed && !this.menuItem.exclude && urlInfo.isValidUrl && urlInfo.goesToSameSite()) {
        event.preventDefault();
        this.isActive = true;
        this.setActiveLink(this.menuItem.id, this.parentId, event.target);
        if (this.menuItem.hasChildren && !this.expanded) {
          this.toggleMenu(this.menuItem.id, this.menuItem.childSortOrder);
        }
        this.loadPartialView(url, true).then(isSuccess => {
          if(!isSuccess) {
            this.linkFailed = true;
            event.target.click();
          }
        });
      }
    },
    setActiveLink: function (id, perentId, target) {
      this.$emit("setActiveLink", id, perentId, target);
    },
    loadPartialView: async function (url, push) {
      var response = await this.menuservice.loadPartialView(url);
      return loadview.loadPartialViewMobile (
          response,
          push,
          url,
          this.navigatedText
        );
    },
    getNextLevel: function (id, sort) {
      if (this.level < 4) {
        this.menuservice
          .getNextLevel(this.baseApiUrl, id, sort, this.userOrganisationUids, this.userProgramCodes, this.userUmuId, true)
          .then((result) => {
            if (result && result.status === 200) {
              this.nextLevel = result.data;
              if (this.nextLevel.menuItems.length) {
                this.expanded = true;
              }
            }
          });
      }
    },
  },
};
</script>
